import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
};

const cakeCartSlice = createSlice({
  name: 'cakeCart',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
      localStorage.setItem('selectedCakes', JSON.stringify(action.payload));
    },
    updateQuantity: (state, action) => {
      const { id, change } = action.payload;
      state.cartItems = state.cartItems
        .map((item) =>
          item.id === id ? { ...item, quantity: Math.max(1, item.quantity + change) } : item
        )
        .filter((item) => item.quantity > 0);
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    updateManualQuantity: (state, action) => {
      const { id, value } = action.payload;
      const quantity = parseInt(value);
      if (isNaN(quantity) || quantity < 1) return;
      state.cartItems = state.cartItems.map((item) =>
        item.id === id ? { ...item, quantity } : item
      );
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    removeItem: (state, action) => {
      state.cartItems = state.cartItems.filter((item) => item.id !== action.payload);
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
    addToCart: (state, action) => {
      const product = action.payload;
      const exist = state.cartItems.find((i) => i.id === product.id);
      if (exist) {
        state.cartItems = state.cartItems.map((i) =>
          i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      } else {
        state.cartItems = [...state.cartItems, { ...product, quantity: 1 }];
      }
      localStorage.setItem('selectedCakes', JSON.stringify(state.cartItems));
    },
  },
});

export const { setCartItems, updateQuantity, updateManualQuantity, removeItem, addToCart } =
  cakeCartSlice.actions;

export default cakeCartSlice.reducer;

// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   cartItems: [],
//   totals: { total: 0, gst: 0 },
//   totalItems: 0,
// };

// const cakeCartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     setCartItems: (state, action) => {
//       state.cartItems = action.payload;
//       state.totalItems = action.payload.reduce((sum, item) => sum + item.quantity, 0);
//       state.totals = action.payload.reduce(
//         (acc, item) => {
//           const price = parseFloat(item.base_price);
//           const gstRate = parseFloat(item.tax_rate);
//           const gstAmtPerItem = (price * gstRate) / 100;
//           const totalPerItem = price + gstAmtPerItem;
//           acc.gst += gstAmtPerItem * item.quantity;
//           acc.total += totalPerItem * item.quantity;
//           return acc;
//         },
//         { total: 0, gst: 0 }
//       );
//     },
//     addToCart: (state, action) => {
//       const product = action.payload;
//       const exist = state.cartItems.find((i) => i.id === product.id);
//       let updated;
//       if (exist) {
//         updated = state.cartItems.map((i) =>
//           i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i
//         );
//       } else {
//         updated = [...state.cartItems, { ...product, quantity: 1 }];
//       }
//       state.cartItems = updated;
//       state.totalItems = updated.reduce((sum, item) => sum + item.quantity, 0);
//       state.totals = updated.reduce(
//         (acc, item) => {
//           const price = parseFloat(item.base_price);
//           const gstRate = parseFloat(item.tax_rate);
//           const gstAmtPerItem = (price * gstRate) / 100;
//           const totalPerItem = price + gstAmtPerItem;
//           acc.gst += gstAmtPerItem * item.quantity;
//           acc.total += totalPerItem * item.quantity;
//           return acc;
//         },
//         { total: 0, gst: 0 }
//       );
//       localStorage.setItem('selectedCakes', JSON.stringify(updated));
//     },
//     updateQuantity: (state, action) => {
//       const { id, change } = action.payload;
//       const updated = state.cartItems
//         .map((i) =>
//           i.id === id ? { ...i, quantity: Math.max(1, i.quantity + change) } : i
//         )
//         .filter((i) => i.quantity > 0);
//       state.cartItems = updated;
//       state.totalItems = updated.reduce((sum, item) => sum + item.quantity, 0);
//       state.totals = updated.reduce(
//         (acc, item) => {
//           const price = parseFloat(item.base_price);
//           const gstRate = parseFloat(item.tax_rate);
//           const gstAmtPerItem = (price * gstRate) / 100;
//           const totalPerItem = price + gstAmtPerItem;
//           acc.gst += gstAmtPerItem * item.quantity;
//           acc.total += totalPerItem * item.quantity;
//           return acc;
//         },
//         { total: 0, gst: 0 }
//       );
//       localStorage.setItem('selectedCakes', JSON.stringify(updated));
//     },
//     removeItem: (state, action) => {
//       const updated = state.cartItems.filter((item) => item.id !== action.payload);
//       state.cartItems = updated;
//       state.totalItems = updated.reduce((sum, item) => sum + item.quantity, 0);
//       state.totals = updated.reduce(
//         (acc, item) => {
//           const price = parseFloat(item.base_price);
//           const gstRate = parseFloat(item.tax_rate);
//           const gstAmtPerItem = (price * gstRate) / 100;
//           const totalPerItem = price + gstAmtPerItem;
//           acc.gst += gstAmtPerItem * item.quantity;
//           acc.total += totalPerItem * item.quantity;
//           return acc;
//         },
//         { total: 0, gst: 0 }
//       );
//       localStorage.setItem('selectedCakes', JSON.stringify(updated));
//     },
//     setManualQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       if (isNaN(quantity) || quantity < 1) return;
//       const updated = state.cartItems.map((item) =>
//         item.id === id ? { ...item, quantity } : item
//       );
//       state.cartItems = updated;
//       state.totalItems = updated.reduce((sum, item) => sum + item.quantity, 0);
//       state.totals = updated.reduce(
//         (acc, item) => {
//           const price = parseFloat(item.base_price);
//           const gstRate = parseFloat(item.tax_rate);
//           const gstAmtPerItem = (price * gstRate) / 100;
//           const totalPerItem = price + gstAmtPerItem;
//           acc.gst += gstAmtPerItem * item.quantity;
//           acc.total += totalPerItem * item.quantity;
//           return acc;
//         },
//         { total: 0, gst: 0 }
//       );
//       localStorage.setItem('selectedCakes', JSON.stringify(updated));
//     },
//   },
// });

// export const { setCartItems, addToCart, updateQuantity, removeItem, setManualQuantity } =
//   cakeCartSlice.actions;

// export default cakeCartSlice.reducer;